'use client'

import { IconType } from 'react-icons'

import { Box, Button, Divider, Flex, Icon, Text } from '@chakra-ui/react'

import { Colors } from '@/styles/colors'

export const ActionBar = ({
  label,
  primaryButton,
  secondaryButton,
}: ActionBarProps) => {
  const bgColor = Colors.hiveWatchDarkBlue
  const borderColor = Colors.hiveWatchDarkBlue
  const dividerColor = Colors.gray300
  const textLabelColor = Colors.white
  const buttonSize = 'sm'

  return (
    <Box
      bottom={6}
      left='50%'
      position='fixed'
      transform='translateX(-50%)'
      // Value found through trial and error. Currently hardcoded so that it
      // sits below the Active Incidents drawer when expanded and on a narrow screen
      zIndex={10}
    >
      <Flex
        align='center'
        bg={bgColor}
        borderColor={borderColor}
        borderRadius='full'
        borderWidth={1}
        boxShadow='lg'
        gap={4}
        px={6}
        py={3}
      >
        <Text color={textLabelColor} fontSize='sm' fontWeight='medium'>
          {label}
        </Text>

        <Divider borderColor={dividerColor} height={4} orientation='vertical' />

        {/* region Secondary button */}
        {secondaryButton && (
          <Button
            leftIcon={
              secondaryButton.icon ? (
                <Icon as={secondaryButton.icon} boxSize={6} />
              ) : undefined
            }
            onClick={secondaryButton.onClick}
            size={buttonSize}
            variant='secondary'
          >
            {secondaryButton.text}
          </Button>
        )}
        {/* endregion */}

        {/* region Primary button */}
        <Button
          leftIcon={
            primaryButton.icon ? (
              <Icon as={primaryButton.icon} boxSize={6} />
            ) : undefined
          }
          onClick={primaryButton.onClick}
          size={buttonSize}
          variant='primary'
        >
          {primaryButton.text}
        </Button>
        {/* endregion */}
      </Flex>
    </Box>
  )
}

type ActionBarProps = {
  label: string
  primaryButton: ActionBarButtonProps
  secondaryButton?: ActionBarButtonProps
}

type ActionBarButtonProps = {
  icon?: IconType
  text: string
  onClick: () => void
}
